"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.sort.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

var _useProducts2 = _interopRequireDefault(require("../../productList/hooks/useProducts"));

var _useColors = _interopRequireDefault(require("../../hooks/useColors"));

var _MenuItem = _interopRequireDefault(require("../largeMenu/MenuItem"));

var _Product = _interopRequireDefault(require("./Product"));

var _VerticalProductsWrapper = _interopRequireDefault(require("./VerticalProductsWrapper"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles.less");

var styles = {
  "menuWrapper": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menuWrapper",
  "visible": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__visible",
  "menu": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu",
  "menu-horizontal": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-horizontal",
  "menu-horizontal-4": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-horizontal-4",
  "menuContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menuContent",
  "menu-horizontal-6": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-horizontal-6",
  "menu-vertical": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical",
  "menu-vertical-1": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-1",
  "menu-vertical-2": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-2",
  "menu-vertical-4": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-4",
  "menu-vertical-5": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__menu-vertical-5",
  "productHorizontal": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productHorizontal",
  "productsHorizontalContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productsHorizontalContent",
  "productVertical": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productVertical",
  "productTitle": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productTitle",
  "productsVerticalContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productsVerticalContent",
  "productImage": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productImage",
  "productContent": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productContent",
  "productPrice": "meepshop-meep-ui__submenu-largeMenuWithProducts-styles__productPrice"
};

var getVariant = function getVariant(imageTextAlignment, count) {
  if (!count) {
    return 0;
  }

  if (imageTextAlignment === 'horizontal') {
    if (count < 4) {
      return 6; // .menuContent-horizontal-6
    }

    return 4; // .menuContent-horizontal-4
  }

  if (count > 3) {
    return 1; // .menuContent-horizontal-1
  }

  if (count === 3) {
    return 2; // .menuContent-horizontal-2
  }

  if (count === 2) {
    return 4; // .menuContent-horizontal-4
  }

  return 5; // .menuContent-horizontal-5
};

var getImageMaxWidth = function getImageMaxWidth(imageTextAlignment, ratio) {
  if (imageTextAlignment === 'vertical') {
    if (ratio === '4 / 3') {
      return 248;
    }

    return 186;
  }

  if (ratio === '4 / 3') {
    return 134;
  }

  return 100;
};

var MenuContent = function MenuContent(_ref) {
  var _data$computeProductL, _products$length;

  var visible = _ref.visible,
      pages = _ref.pages,
      menuSettings = _ref.menuSettings,
      submenuSettings = _ref.submenuSettings;
  // 色彩配置
  var colors = (0, _useColors["default"])();
  var productSettings = submenuSettings.productSettings;
  var params = (0, _react.useMemo)(function () {
    var _productSettings$ids;

    return {
      ids: ((_productSettings$ids = productSettings.ids) === null || _productSettings$ids === void 0 ? void 0 : _productSettings$ids.join(',')) || '',
      offset: 0,
      limit: 6,
      sort: productSettings.sort
    };
  }, [productSettings.ids, productSettings.sort]);

  var _useProducts = (0, _useProducts2["default"])(params),
      data = _useProducts.data;

  var products = data === null || data === void 0 ? void 0 : (_data$computeProductL = data.computeProductList) === null || _data$computeProductL === void 0 ? void 0 : _data$computeProductL.data;
  var imageTextAlignment = productSettings.imageTextAlignment.toLowerCase();
  var variant = getVariant(imageTextAlignment, products === null || products === void 0 ? void 0 : products.length);
  var imageMaxWidth = getImageMaxWidth(imageTextAlignment, productSettings.imageRatio);
  var Wrap = imageTextAlignment === 'vertical' ? _VerticalProductsWrapper["default"] : _react["default"].Fragment;
  var verticalProps = imageTextAlignment === 'vertical' ? {
    itemWidth: imageMaxWidth,
    imageRatio: productSettings.imageRatio,
    count: (_products$length = products === null || products === void 0 ? void 0 : products.length) !== null && _products$length !== void 0 ? _products$length : 0
  } : {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.menuWrapper, " ").concat(visible ? styles.visible : ''),
    style: {
      '--submenu-font-size': menuSettings.submenuFontSize ? "".concat(menuSettings.submenuFontSize, "px") : '16px',
      '--submenu-color': 'var(--color-3)',
      '--submenu-background-color': 'var(--color-2)',
      '--submenu-background-color-hover': (0, _color["default"])(colors[1]).darken(0.05),
      pointerEvents: visible ? 'auto' : 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.menu, " ").concat(styles["menu-".concat(imageTextAlignment)], " ").concat(styles["menu-".concat(imageTextAlignment, "-").concat(variant)])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.menuContent
  }, pages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: page.id,
      page: page,
      menuSettings: menuSettings,
      submenuSettings: submenuSettings
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(Wrap, verticalProps, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.productsContent, " ").concat(imageTextAlignment === 'vertical' ? styles.productsVerticalContent : styles.productsHorizontalContent)
  }, products === null || products === void 0 ? void 0 : products.map(function (product) {
    return /*#__PURE__*/_react["default"].createElement(_Product["default"], {
      key: product.id,
      product: product,
      imageMaxWidth: imageMaxWidth,
      imageTextAlignment: imageTextAlignment,
      imageRatio: productSettings.imageRatio
    });
  }))))));
};

var _default = MenuContent;
exports["default"] = _default;